import { ButtonGroup, LinkButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { useLanguage } from "@digipost/translate";
import React, { FC } from "react";
import { Link, useLocation, useSearchParams } from "react-router";

import styles from "../../js/errorpage/ErrorPage.module.less";
import Translated from "../infrastructure/components/Translated";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { useTranslate } from "../infrastructure/hooks/useTranslate";

const LoginError: FC = () => {
  const [urlParams] = useSearchParams();
  const location = useLocation();
  const { language } = useLanguage();

  const kodeErrorCode = urlParams.get("kode");
  const idpErrorCode = urlParams.get("idpErrorCode");

  const errorCode = kodeErrorCode || idpErrorCode;

  const translate = useTranslate();
  const rootPath = useRootPath();

  const isIdPortenErrorPath = location.pathname.includes("loginError");
  const isSignicatErrorPath = location.pathname.includes("innloggingFeilet");

  const errorMessage = (): React.JSX.Element => {
    if (errorCode === "IKKE_AUTORISERT" && isIdPortenErrorPath) {
      return <Translated textKey={"login.not_registered"} />;
    } else if (errorCode === "IKKE_AUTORISERT" && isSignicatErrorPath) {
      return <Translated textKey={"login.not_access_business"} />;
    } else if (errorCode === "KONTO_SUSPENDERT") {
      return <Translated textKey={"login.account_suspended"} />;
    } else {
      return <Translated textKey={"generic.error_body"} />;
    }
  };

  return (
    <div className={styles.errorContent}>
      <img
        className={styles.oauthIllustration}
        src="/innlogging/images/illustrations/hund-snuser-pakke.svg"
        alt={translate("errorpage.illustration_alt")}
      />
      <div className={styles.errorContentText}>
        <Heading level={1} size={"large"}>
          <Translated textKey={"login.failed_heading"} />
        </Heading>
        {errorMessage()}
        <ButtonGroup className={styles.errorContentLinks}>
          <LinkButton as={Link} to={`${rootPath}/`}>
            <Translated textKey={"errorpage.back_to_login"} />
          </LinkButton>
          <LinkButton as={Link} to={`${rootPath}/business`}>
            <Translated textKey={"errorpage.back_to_login_company"} />
          </LinkButton>
          {errorCode === "IKKE_AUTORISERT" && isSignicatErrorPath && (
            <LinkButton as="a" href={`/registrering${"/" + language}/bedrift/`}>
              <Translated textKey="login.register_business" />
            </LinkButton>
          )}
        </ButtonGroup>
      </div>
    </div>
  );
};

export default LoginError;
